export default function getFileTypeFromPath(path: string) {
  const fileNameParts = path.split('.')
  return fileNameParts[fileNameParts.length - 1].toLowerCase()
}
